module.exports = __webpack_public_path__ + "b769ae88624610ac4cead2666de953a6.jpg";